import { isLyrraOne } from '@/lib/platform';
import InstitutionFlowsPanel from '@/pages/institution/InstitutionFlowsPanel';
import EduFlowListPage from '@/pages/eduflow/EduFlowListPage';

/** Contenu de l’onglet « Formations » sous `/dashboard?tab=flows`. */
export function FormateurFlowsTabContent() {
  if (isLyrraOne()) {
    return <EduFlowListPage embedded />;
  }
  return <InstitutionFlowsPanel />;
}
